module.exports = __webpack_public_path__ + "img/icpedi_06.ee55e136.jpg";